export class IntentOfGeneration {
  description: string;
  displayName: string;
  displayOrder: number;
  intentOfGenerationId: string;
}
